import api from "../api";

export const storageService = {
    async getFileByName(fileName) {
        return await api.get(`/storage/${fileName}`, {
            responseType: "blob",
          }); 
    },
};